import type { ChakraProps } from '@chakra-ui/react';
import type { ChainLayer } from '@cronos-app/sdk';
import type { FC } from 'react';

export enum Token {
  Unknown = 'Unknown',

  CRO = 'CRO',
  CorgiAI = 'CorgiAI',
  FUL = 'FUL',
  USDC = 'USDC',
  USDT = 'USDT',
  LCRO = 'LCRO',
  ETH = 'ETH',
  WBTC = 'WBTC',
  vETH = 'vETH',
  vUSD = 'vUSD',
  DAI = 'DAI',
  zkCRO = 'zkCRO',
  ybETH = 'ybETH',
  ybUSD = 'ybUSD',

  wzkCRO = 'wzkCRO',
  H2 = 'H2',
  MERY = 'MERY',
  MOON = 'MOON',
  AMPLY = 'AMPLY',
  AGENTFUN = 'AGENTFUN',
}

export type KnownToken = Exclude<Token, Token.Unknown>;

export interface TokenConfig {
  readonly type: Token;
  readonly symbol: string;

  readonly addressL1: string;
  readonly addressL2: string;
  readonly addressCronosEvm: string;

  readonly decimals: number;
  readonly displayDecimals: number;

  readonly Icon: FC<ChakraProps>;
}

export type TokenContext =
  | {
      type: Exclude<Token, Token.Unknown>;
      layer: ChainLayer;
    }
  | {
      type: Token.Unknown;
      layer: ChainLayer;
      address: string;
    };
